module.exports = advancedAds.i18n;